import axios, { InternalAxiosRequestConfig } from "axios";
import store from "../store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // ex: https://api.example.com
  timeout: 10000, // 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if ((config as any).skipAuth) {
      return config;
    }
    const state = store.getState();
    const token = state.Auth.token_details?.accessToken;

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only set Content-Type if data is NOT FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    } else {
      // For FormData, delete Content-Type so browser sets it correctly
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default axiosInstance;
